import { call, put, takeLatest } from "redux-saga/effects";
import { ApiError, PaginatedApiResponse } from "@/lib/apiClient";
import {
  getInventory,
  updateInventoryAction,
} from "../actions/inventory.actions";
import {
  fetchInventoryFailure,
  fetchInventoryRequest,
  fetchInventorySuccess,
  updateInventory,
  updateInventoryFailure,
  updateInventorySuccess,
} from "../slices/Inventory.slice";
import { Variant } from "@/types/models/product";

function* fetchInventorySaga(action: ReturnType<typeof fetchInventoryRequest>) {
  try {
    const data: PaginatedApiResponse<Variant[]> = yield call(getInventory, {
      page: action.payload.page,
      pageSize: action.payload.pageSize,
    });
    yield put(
      fetchInventorySuccess({
        list: data.data,
        page: data.pagination.page,
        total: data.pagination.total,
        pageSize: data.pagination.pageSize,
        totalPages: data.pagination.totalPages,
      }),
    );
  } catch (err: unknown) {
    if (err instanceof ApiError) {
      yield put(fetchInventoryFailure(err));
    } else {
      yield put(
        fetchInventoryFailure(
          new ApiError(
            500,
            "UNKNOWN_ERROR",
            (err as any)?.message || "An unexpected error occurred",
          ),
        ),
      );
    }
  }
}

function* updateInventorySaga(action: ReturnType<typeof updateInventory>) {
  try {
    yield call(updateInventoryAction, {
      product_id: action.payload.product_id,
      variant_id: action.payload.variant_id,
      inventory: action.payload.inventory,
    });
    yield put(
      updateInventorySuccess({
        product_id: action.payload.product_id,
        variant_id: action.payload.variant_id,
        inventory: action.payload.inventory,
      }),
    );
  } catch (err: unknown) {
    if (err instanceof ApiError) {
      yield put(updateInventoryFailure(err));
    } else {
      yield put(
        updateInventoryFailure(
          new ApiError(
            500,
            "UNKNOWN_ERROR",
            (err as any)?.message || "An unexpected error occurred",
          ),
        ),
      );
    }
  }
}

export default function* inventoryRootSaga() {
  yield takeLatest(fetchInventoryRequest.type, fetchInventorySaga);
  yield takeLatest(updateInventory.type, updateInventorySaga);
}
